<!-- Loader-->
<div class="div-window_maps_title" *ngIf="!isLoaded">
  <div class="h3 loaderH3">Collaborators</div>
  <div id="loadingText" class="h5">Loading...</div>
</div>

<div class="div-window_maps_title" *ngIf="(isLoaded && !collaborationData)||!userHaveAccess&&isLoaded">
  <div class="h3 loaderH3">Collaborators</div>
  <div id="your-add-ons" style="color: 555555 !important">
    <p>You currently have no Collaborators.</p>
  </div>
</div>

<div
  *ngIf="isLoaded && collaborationData&&userHaveAccess"
  id="your-col-invite"
  class="div-window_maps"
  style="display: block"
>
  <div>
    <div class="h3">Invite Collaborators</div>
    <p>
      Invite users to access your maps by entering their email addresses in the
      box below, separated by commas, and clicking send.
    </p>

    <form
      action="/collaborate/send"
      method="post"
      id="invite_colab_form"
      ngNativeValidate
      (ngSubmit)="send()"
    >
      <input
        class="form-control"
        style="border-radius: 0px"
        name="emails"
        placeholder="Email Address 1, Email Address 2, ... "
        type="text"
        [(ngModel)]="emails"
        required
      />
      <div
        class="colab-custom-options"
        style="display: block"
        *ngIf="moreOptions"
        id="more_options_testing"
      >
        <p>
          Get more specific by naming a map in the invite email. This is just
          for communication purpose -- your invitees will still be able to
          access all maps.
        </p>
        <select
          class="colab-drop-down"
          name="colab_map_name"
          (change)="onChange($event)"
        >
          <option value="0">Choose map</option>
          <option [value]="aMaps.map_id" *ngFor="let aMaps of maps">
            {{ aMaps.map_name }}
          </option>
        </select>
        <p>
          Add a customized message to your recipients here. It will appear as
          the preview text, displaying after the Subject line in most email
          programs.
        </p>
        <input
          class="form-control"
          style="border-radius: 0px"
          name="preview_text"
          id="preview_text"
          placeholder="Email preview text"
          type="text"
          [(ngModel)]="previewText"
        />
      </div>
      <div class="btn_div">
        <button
          type="submit"
          id="sendInviteEmailSubmit"
          style="display: none"
        ></button>
        <button
          type="submit"
          id="sendInviteEmail"
          class="btn accept-btn gernal-btn"
        >
          Send
        </button>
        <button
          *ngIf="!moreOptions"
          type="button"
          (click)="showMoreOptions()"
          class="more-option-text"
        >
          More options...
        </button>
        <button
          *ngIf="moreOptions"
          type="button"
          class="btn back-btn-right"
          (click)="back()"
          style="display: inline-block"
        >
          Back
        </button>
        <span style="float: right; display: none" id="select_product"
          >Invite to which product?
          <select name="select_product_type">
            <option value="1" selected="selected">PARCEL VIEWER</option>

            <option value=" 1  ">All</option>
          </select>
        </span>
      </div>
    </form>
  </div>
</div>

<!-- text rendering from backend api -->

<div
  id="collab-dashboard-text"
  class="dashboard-map-text"
  style="width: 40%"
  [innerHtml]="text | sanitizeHtml"
  *ngIf="isLoaded && text"
></div>

<div
  id="pending-invited"
  class="Pending-collaborater-invite div-window_maps"
  *ngIf="pendingUsers?.length !== 0 && collaborationData && isLoaded&&userHaveAccess"
>
  <div class="h3 sub-head-pv">Pending Invitations</div>
  <table class="table">
    <tbody>
      <tr *ngFor="let user of pendingUsers">
        <td>{{ user.email }}</td>
        <td>
          <form action="/collaborate/send" method="post">
            <input
              class="form-control"
              value="{{ user.email }}"
              name="emails"
              placeholder="Email Address 1, Email Address 2, ... "
              type="hidden"
            />
            <input
              class="form-control"
              value="1"
              name="select_product_type"
              type="hidden"
            />
            <span class="input-group-btn">
              <input
                class="btn btn-secondary pending-invite-btn"
                type="submit"
                value="Resend"
                (click)="resend(user.email, user.product_type)"
              />
              <button
                class="PendingCancel btn btn-secondary pending-invite-btn"
                type="button"
                (click)="cancelInvitation(user.id)"
              >
                Cancel
              </button>
            </span>
          </form>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div
  id="your-col-invited-user"
  class="hide_forms div-window_maps"
  *ngIf="current_users && collaborationData && isLoaded&&userHaveAccess"
>
  <div>
    <p *ngIf="current_users.length === 0">
      You have not invited any collaborators to access your subscribed maps.
    </p>
    <button
      *ngIf="!editCurrentCollab && current_users.length !== 0"
      (click)="isEditCurrentCollab()"
      type="button"
      style="margin-bottom: 0px !important"
      class="text-btn show-current-col-items"
    >
      Edit
    </button>
    <table class="table">
      <tbody>
        <tr>
          <td class="h4">Current Collaborators</td>

          <td
            class="p2Simple"
            style="text-align: center"
            *ngIf="current_users.length !== 0"
          >
            Last Login
          </td>
          <td
            *ngIf="editCurrentCollab && current_users.length !== 0"
            class="p2Simple hide-current-col-items"
            style="text-align: center; display: block"
          >
            Remove
          </td>
        </tr>

        <tr *ngFor="let user of current_users; index as i">
          <td>
            <p class="p">
              {{ user.subscriber__first_name }} {{ user.subscriber__last_name }}
            </p>
          </td>

          <td style="text-align: right">
            <p class="p">
              {{ user.subscriber__last_login | date: "MMM. dd, Y, h:mm " }}
              {{ user.subscriber__last_login | date: "a" | lowercase }}
            </p>
          </td>
          <td
            *ngIf="editCurrentCollab"
            style="text-align: center; width: 60px; display: block"
            class="hide-current-col-items"
          >
            <input
              class="col-checked"
              id="1168"
              type="checkbox"
              [value]="user.id"
              name="1168"
              [checked]="check[i]"
              (change)="onChangeCurrent($event, i)"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div
      style="text-align: right; display: block"
      *ngIf="editCurrentCollab && current_users.length !== 0"
    >
      <button
        type="button"
        id="cancel-current-col"
        (click)="cancelCurrentCollab()"
        class="hide-current-col-items btn gernal-btn"
      >
        Back
      </button>
      <button
        id="CollaborateRemove"
        type="submit"
        (click)="cancelAllCollab()"
        class="btn gernal-btn hide-current-col-items"
      >
        Submit
      </button>
    </div>
  </div>
</div>
